import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routes";
import "devextreme/dist/css/dx.common.css";
import "./assets/custom.css";
import "./assets/dx.material.integration.css";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
    applicationId: '7fe3f51e-0872-4359-8839-47f52148a7df',
    clientToken: 'pub286d2df768fa96f73a85f7fd5b0418bd',
    site: 'us3.datadoghq.com',
    service: 'pds',
    env: 'production',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: 'mask-user-input',
});
datadogRum.startSessionReplayRecording();

const rootElement = document.getElementById("root");

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#8b0304",
    },
    secondary: {
      main: "#fff",
    },
  },
  typography: {
    fontFamily: ["Roboto Condensed", "sans-serif"].join(","),
  },
});

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <Routes />
  </MuiThemeProvider>,
  rootElement
);
